/**
 * A per-browser boolean remembered in localStorage, for UI conveniences such
 * as "did this viewer leave a section open". Storage can be unavailable
 * (private mode, blocked site data) or throw, so both directions swallow
 * errors: the UI still works for the current visit.
 */
export function readPersistedFlag(key: string, fallback = false): boolean {
  try {
    const stored = window.localStorage.getItem(key);
    return stored === null ? fallback : stored === 'true';
  } catch {
    return fallback;
  }
}

export function writePersistedFlag(key: string, value: boolean): void {
  try {
    window.localStorage.setItem(key, String(value));
  } catch {
    // Unavailable storage only loses the memory of the choice.
  }
}
